import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "../../../types/responseError"
import { HttpErrors } from "#/utils/HttpErrors"
import { useAuthentication } from "#/components/context/authentication/AuthenticationProvider"
import { carrotClient } from "#/utils/CarrotClient"

const ENDPOINT = "GetBlueshiftUuid"

const loadBlueshiftUuid = async (handleSessionExpiration: () => void) => {
  try {
    return await carrotClient.getBlueshiftUuid()
  } catch (error) {
    if (error.name === HttpErrors.UNAUTHORIZED || error.name === HttpErrors.FORBIDDEN) {
      handleSessionExpiration()
    }
    return null
  }
}

const getBlueshiftUuidCacheKey = (): string[] => [ENDPOINT]

const NON_RETRYABLE_ERRORS = new Set([HttpErrors.NOT_FOUND, HttpErrors.UNPROCESSABLE_ENTITY])

export default function useGetBlueshiftUuid(): UseQueryResult<string, ResponseError> {
  const { handleSessionExpiration } = useAuthentication()
  return useQuery<string, ResponseError>({
    queryKey: getBlueshiftUuidCacheKey(),
    queryFn: () => loadBlueshiftUuid(handleSessionExpiration),
    retry: (_, error) => !NON_RETRYABLE_ERRORS.has(error?.name)
  })
}
